import { ReactNode } from 'react';
import { statusBadgeClass } from '../../utils/statusBadge';
import type { StatusBadgeTone } from '../../utils/StatusBadgeTone';

type StatusBadgeProps = {
  tone?: StatusBadgeTone;
  children: ReactNode;
  className?: string;
};

export function StatusBadge({ tone = 'neutral', children, className = '' }: StatusBadgeProps) {
  return <span className={`${statusBadgeClass(tone)} ${className}`.trim()}>{children}</span>;
}
